/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import fdDataTable from '../../js/app/dataTable/fdDataTable';
import ccTab from '@/components/common/tab/index.vue';
import ehartsBase from '@/components/common/echarts/echarts-base.vue';
import pieEcharts from '@/components/app/pieEcharts2/index.vue';
import barRedEcharts from '@/components/app/barEcharts03/index.vue';
// 所有tab的change事件放到这个文件
import tabChange from './mixins/tabChange';

export default {
    name: 'index',
    components: {ccTab, ehartsBase, pieEcharts, barRedEcharts},
    mixins: [tabChange],
    data() {
        return {
            fyActive: null,
            // 头条新闻的内容
            tt: {
                name: '',
                content: '',
                xwlb: '内容正在维护更新中'
            },
            // 图片新闻
            imgList: null,
            activeImg: 0,
            // 新闻资讯的新闻
            xwzxList: null,
            xxxsdList: [],
            inter: null,
            fyggData: [],
            fyggTable: [],
            kyxxData: {},
            cbkyTable: [],
            pmxxData: [],
            cbplList: [],
            hsalData: {},
            hsalTable: [],
            llttData: {},
            llttTable: [],
            sptbData: {},
            sptbTable: [],
            Data: {},
            ywsfData: {},
            ywsfTable: [],
            hszcData: {},
            hszcTable: [],
            hsfyList: fdDataTable.hsfyList,
            fyjs: {
                fyzpdz: '',
                gjfb: {},
                person: {
                    imgUrl: '',
                    name: '',
                    zw: '',
                    gs: ''
                }
            },
            ztzlData: {},
            ztzlList: [],
            activeFirst: 0,
            // 全国海事法院收结案情况
            qghsfysjaqk: {
                id: 'qghsfysjaqk',
                options: fdDataTable.barOptions

            },
            newsTimer: null,
            bdwpmjdData: [],
            cjbdwzData: [],
            fyxx: {
                '1100': [
                    {
                        name: '辽宁',
                        code: '600'
                    },
                    {
                        name: '天津',
                        code: '51'
                    },
                    {
                        name: '山东',
                        code: '1850'
                    },
                    {
                        name: '江苏',
                        code: '1150'
                    },
                    {
                        name: '上海',
                        code: '1100'
                    },
                    {
                        name: '湖北',
                        code: '2250'
                    },
                    {
                        name: '浙江',
                        code: '1300'
                    },
                    {
                        name: '福建',
                        code: '1600'
                    },
                    {
                        name: '广东',
                        code: '2550'
                    },
                    {
                        name: '广西',
                        code: '2750'
                    },
                    {
                        name: '海南',
                        code: '2900'
                    }
                ],
                '1129': [
                    {
                        name: '大连',
                        code: '732'
                    },
                    {
                        name: '天津',
                        code: '72'
                    },
                    {
                        name: '青岛',
                        code: '2010'
                    },
                    {
                        name: '南京',
                        code: '1151'
                    },
                    {
                        name: '上海',
                        code: '1129'
                    },
                    {
                        name: '武汉',
                        code: '2367'
                    },
                    {
                        name: '宁波',
                        code: '1402'
                    },
                    {
                        name: '厦门',
                        code: '1693'
                    },
                    {
                        name: '广州',
                        code: '2701'
                    },
                    {
                        name: '北海',
                        code: '2878'
                    },
                    {
                        name: '海口',
                        code: '2925'
                    }]
            },
            // 年度的下拉值
            yearList: [],
            // 审执数据的的绑定值
            szsj: new Date().getFullYear()
                .toString(),
            top: 0,
            // 学习新时代的滚动事件
            timer: null,
            // 法律法规数据
            flfgTable:[],
            // 司法解释数据
            sfjsTable:[],
            // 司法文件数据
            sfwjTable:[],
            // 约与惯例数据
            tyyglTable:[]
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        marginLeft() {
            return `-${this.activeFirst * 284}px`;
        }
    },
    methods: {
        init() {
            // 获取审执数据下拉值
            this.initYear();
            this.initXxxsd();
            // 资讯
            this.initXwzx();
            // 公告
            this.initFygg();
            // 扣押
            this.initKyxx();
            // 拍卖
            this.initPmxx();
            // 司法案例
            this.initHsal();
            this.initLltt();
            // this.initSptb();
            this.initSfwj();
            // this.initYwsf();
            // this.initHszc();
            // 专题信息
            this.initZtzl();
            // 法院简介
            // this.initFyjj('0');
            // 审执数据
            this.initSzsj();
            this.initPmfx();
        },
        overflowHidden: function (el, height) {
            const s = (el.textContent || el.innerText).split('');
            const LEN = 3;
            if (s.length > LEN) {
                for (let i = 3; i < s.length + 1; i++) {
                    el.innerHTML = s.slice(0, i)
                        .join('');
                    if (height < el.scrollHeight) {
                        el.innerHTML = `${s.splice(0, i - LEN)
                            .join('')}...`;
                        break;
                    }
                }
            }
        },
        goToXxxsd1() {
            this.$router.push({name: 'xxxsd'});
        },
        // 获取审执数据下拉值
        initYear() {
            const list = [];
            const _year = new Date().getFullYear();
            for (let i = 0; i < 3; i++) {
                const result = Number(_year) - i;
                list.push({
                    name: result,
                    code: result.toString()
                });
            }
            this.yearList = list;
        },
        // 获取拍卖分析初始化数据
        initPmfx() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.pmfx,
                params: {
                    tjsj: (new Date().getFullYear() - 1)
                        .toString()
                }
            })
                .then((res) => {
                    // 标的物种类
                    this.cjbdwzData = this.handleTop5(res.data.pmfxBdwVOList, 'bdlbTranslateText', 'bdwCount');
                    // 拍卖阶段
                    const _data2 = [];
                    res.data.pmfxPmjdVOList.forEach((item) => {
                        _data2.push({
                            name: item.pmjdTranslateText,
                            value: item.pmjdCount
                        });
                    });
                    this.bdwpmjdData = _data2;
                });
        },
        // 处理只展示top5+其他
        handleTop5(data, name, key, conversion) {
            let copyData = [...data];
            // 需要返回的数据
            const rtData = [];
            // 其他类总数
            let pmfxBdwVOTotal = 0;
            // 需要筛选的数据(其他财产类)
            let filterData = null;
            const filteDataIndex = data.findIndex(item => item.bdlb === '255');
            if (filteDataIndex !== -1) {
                // 将筛选出来的保存
                filterData = copyData.splice(filteDataIndex, 1);
                pmfxBdwVOTotal += Number(filterData[0][key]);
            }
            // splice会改变原数组，所以当前数组已经没有其他财产类
            copyData = copyData.sort(this.compare(key));
            copyData.forEach((item, index) => {
                // 可能没有返回数据，默认为0
                if (!item[key]) {
                    item[key] = 0;
                } else if (conversion) {
                    // 四舍五入保留两位
                    item[key] = Math.round(item[key] / 10000 * 100) / 100;
                }
                // 只展示前五
                if (index < 5) {
                    rtData.push({
                        name: item[name],
                        value: item[key]
                    });
                } else {
                    // 大于五展示为其他
                    pmfxBdwVOTotal += Number(item[key]);
                }
            });
            if (pmfxBdwVOTotal) {
                if (conversion) {
                    // 四舍五入保留两位
                    pmfxBdwVOTotal = Math.round(pmfxBdwVOTotal / 10000 * 100) / 100;
                }
                rtData.push({
                    name: '其他',
                    value: pmfxBdwVOTotal
                });
            }
            return rtData;
        },
        // 排序
        compare(property) {
            return function (a, b) {
                const value1 = a[property];
                const value2 = b[property];
                return value2 - value1;
            };
        },
        clickLeft() {
            if (this.activeFirst > 3) {
                this.activeFirst -= 4;
            } else {
                this.activeFirst = 0;
            }
        },
        clickRight() {
            if (this.activeFirst < this.ztzlList.length - 4) {
                this.activeFirst += 4;
            }
        },
        // 轮播
        swipperInit() {
            $('#news_banner')
                .addBanner({
                    index: 0,
                    selectedClass: 'js-active',
                    classType: 'only',
                    mouseType: 'click',
                    container: '.swipper_container',
                    navContainer: '.nav_container',
                    nav: '.swipper_nav',
                    tweenTime: 2000,
                    effect:'fade',
                    delay: 6000,
                    autoPlay: true,
                    isVertical: false,
                    isFullScreen: false,
                    callBack: this.siwpperCallback()
                });
        },
        siwpperCallback() {
            this.$nextTick(() => {
                const TIME = 100;
                this.newsTimer = setInterval(() => {
                    this.activeImg = $('#news_footer')
                        .find('.js-active')
                        .index();
                }, TIME);
            });
        },
        initXxxsd() {
            const url = window.fdConfig.url.home.latestXxxsd;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.xxxsdList = res.data;
                        this.$nextTick(() => {
                            this.setIter();
                        });
                    }
                });
        },
        setIter() {
            const _this = this;
            const dom = $('#xxxsd');
            this.timer = setInterval(() => {
                if (_this.top > -170) {
                    dom.css('transition', 'top 1s linear');
                    dom.css({top:_this.top - 56});
                    _this.top = _this.top - 56;
                    if (_this.top === -224) {
                        dom.css('transition', 'top 0s linear');
                        _this.top = 0;
                        dom.css('top', 0);
                        setTimeout(() => {
                            dom.css('transition', 'top 1s linear');
                            dom.css({top:_this.top - 56});
                            _this.top = _this.top - 56;
                        }, 2000);
                    }
                }
            }, 6000);
        },
        initXwzx() {
            const url = window.fdConfig.url.home.latestNews;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data && res.data.length > 0) {
                        const result = res.data;
                        const imageList = [];
                        const xwzxList = [];
                        for (let i = 0; i < result.length; i++) {
                            // if (i === 0) {
                            //     this.tt = {name: result[i].bt, content: result[i].zy, bh: result[i].bh, xwlb: result[i].xwlb};
                            //     // 如果没有则展示默认图片
                            //     imageList.push({
                            //         src: result[i].imageUrl ? result[i].imageUrl : '/static/image/lb-no-data.png',
                            //         id: result[i].bh,
                            //         title: result[i].bt
                            //     });
                            // } else {
                            //
                            // }
                            // 取图片新闻
                            if (result[i].imageUrl) {
                                imageList.push({
                                    src: result[i].imageUrl,
                                    id: result[i].bh,
                                    title: result[i].bt
                                });
                                continue;
                            }
                            // imageList.push({
                            //     src: result[i].imageUrl ? result[i].imageUrl : '/static/image/lb-no-data.png',
                            //     id: result[i].bh,
                            //     title: result[i].bt
                            // });
                        //    if (result[i].fbdw === '中国' || result[i].fbdw === '最高') {
                            if (result[i].fbdw === '中国' ) {
                                result[i].fbdw = '系统';
                            }

                            xwzxList.push({
                                title: result[i].bt,
                                fy: result[i].fbdw,
                                id: result[i].bh,
                                date: result[i].fbsj,
                                fycj: result[i].fycj,
                                gjlb: result[i].gjlb
                            });
                        }
                        this.imgList = imageList;
                        this.xwzxList = xwzxList;
                        this.$nextTick(() => {
                            this.swipperInit();
                        });
                    }
                });
        },
        // 审执数据时间的切换事件
        changeSzsj(item) {
            this.szsj = item.code;
        },
        initFygg() {
            const url = window.fdConfig.url.home.latestFygg;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {

                        const result = res.data;
                        this.fyggData = result;
                        // 送达公告对应的code为6 改为开庭公告
                        this.fyggTable = result['7'];
                        console.log(this);
                    }
                });
        },
        initKyxx() {
            const url = window.fdConfig.url.home.latestKyxx;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.kyxxData = res.data;
                        // 船舶扣押对应的code为cbky
                        this.cbkyTable = this.kyxxData['cbky'];
                    }
                });
        },
        initPmxx() {
            const url = window.fdConfig.url.home.latestCbpm;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.pmxxData = res.data;
                        // 船舶扣押对应的code为cbky
                        this.cbplList = this.pmxxData['cbpm'];
                    }
                });
        },
        initHsal() {
            const url = window.fdConfig.url.home.latestHsal;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.hsalData = res.data;
                        // 指导性案例对应的code为 0
                        this.hsalTable = this.hsalData['0'];
                    }
                });
        },
        initLltt() {
            const url = window.fdConfig.url.home.latestLltt;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.llttData = res.data;
                        // 指导性案例对应的code为 3
                        this.llttTable = this.llttData['3'];
                    }
                });
        },
        initSptb() {
            const url = window.fdConfig.url.home.latestSptb;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.sptbData = res.data;
                        // 指导性案例对应的code为 5
                        this.sptbTable = this.sptbData['5'];
                    }
                });
        },
        initSfwj() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.hsalindex.replace('{id}', '3')
            }).then((res) => {
                this.sfjsTable = res.data.sfjs;
                this.flfgTable = res.data.flfg;
                this.sfwjTable = res.data.zdxwj;
                this.tyyglTable = res.data.gjgy;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        },
        initYwsf() {
            const url = window.fdConfig.url.home.latestYwsf;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.ywsfData = res.data;
                        // 指导性案例对应的code为 10
                        this.ywsfTable = this.ywsfData['10'];
                        // this.$nextTick(() => {
                        //     const Dom = document.getElementById('ywsf');
                        //     this.overflowHidden(Dom, 56);
                        // });
                    }
                });
        },
        initHszc() {
            const url = window.fdConfig.url.home.latestHszc;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.hszcData = res.data;
                        // 指导性案例对应的code为 0
                        this.hszcTable = this.hszcData['15'];
                    }
                });
        },
        initZtzl() {
            const url = window.fdConfig.url.home.latestZtxx;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.ztzlList = res.data;
                    }
                });
        },
        initFyjj(fydm) {
            this.fyActive = fydm;
            const url = window.fdConfig.url.fyjs.fyjs.replace('{fydm}', fydm);
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.fyjs = res.data;
                    }
                });
        },
        initSzsj() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.szsjtj.countForSpajtjHsfysj,
                params: {tjsj: this.szsj}
            })
                .then((res) => {
                    const xsData = res.data.xsData;
                    const jaData = res.data.jaData;
                    const wjData = res.data.wjData;
                    const max = res.data.max;
                    this.initQghsfysjaqk(xsData, jaData, wjData, max);
                });
        },
        initQghsfysjaqk(xsData, jaData, wjData, max) {
            // max表示所有数据中的最大值，也就是y轴的最大值
            const maxArr = new Array(11).fill(max);
            // 新收案件背后柱子的高度
            const xsDataBg = [];
            // 结案案件背后柱子的高度
            const jaDataBg = [];
            // 旧存案件背后柱子的高度
            const wjDataBg = [];
            // 因为最后背景柱子的高度是y轴的总高度，减去下面柱子的高度;
            for (let i = 0; i < 11; i++) {
                xsDataBg.push(maxArr[i] - xsData[i]);
                wjDataBg.push(maxArr[i] - wjData[i]);
                jaDataBg.push(maxArr[i] - jaData[i]);
            }
            this.qghsfysjaqk.options.series[0].data = xsData;
            this.qghsfysjaqk.options.series[1].data = xsData;
            this.qghsfysjaqk.options.series[2].data = jaData;
            this.qghsfysjaqk.options.series[3].data = jaData;
            this.qghsfysjaqk.options.series[4].data = wjData;
            this.qghsfysjaqk.options.series[5].data = wjData;
        },
        // 打开其他网站链接
        openUrl(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        getKssj() {
            const day1 = new Date();
            day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
            return String(String(String(day1.getFullYear() - 1) + (day1.getMonth() + 1)) + day1.getDate());
        },

        getJssj() {
            const day1 = new Date();
            day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
            return String(String(String(day1.getFullYear()) + (day1.getMonth() + 1)) + day1.getDate());
        },
        cutData(data, len) {
            if (data) {
                return data.slice(0, len);
            }
        },
        goToFyjs(code) {
            const url = this.$router.resolve({path: '/fyjs', query: {tab: 'fyjs', code: code}});
            window.open(url.href, '_blank');
        },
        // 获取多行省略
        getOverflowEllipsis(str, num = 145) {
            const _str = str.replace(/\s+/g, ' ');
            return _str.length > num ? `${_str.substring(0, num)}...` : str;
        }
    },
    destroyed() {
        clearInterval(this.newsTimer);
        clearInterval(this.timer);
    }
};

